import SpectrumCardHoverable from "./SpectrumCardHoverable";
import styles from "./spectraArray.module.css";

const SpectraArrayHoverable = ({ data, ...rest }) => {
  const content = data?.map((spectrum_id) => {
    const spectrumCard = (
      <SpectrumCardHoverable key={spectrum_id} id={spectrum_id} />
    );
    return spectrumCard;
  });

  return <div className={styles.spectraArray}>{content}</div>;
};

export default SpectraArrayHoverable;
